import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allAccessLog,accessIntercept} from '../../api'
 

  
export default /*#__PURE__*/_defineComponent({
  __name: 'accessLogList',
  setup(__props) {

  const search = reactive({
    type: "0", 
	key:""
  })
 

  

  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
     { title: "账号", key: "userName", align: "center"}, 
     { title: "访问地址", key: "path", align: "center" },
	 { title: "ip", key: "ip", align: "center" },  
	 { title: "来源", key: "referer", align: "center" },  
	 { title: "头部", key: "userAgent", align: "center" },   
	 { title: "状态", key: "state", align: "center", customSlot: "state" }, 
     { title: "访问时间", key: "addTime", align: "center" }, 
	 
	 
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllAccessLog = () => {
    loading.value = true;
	
    var data = { "page": page.current, "limit": page.limit, "type": search.type,"key": search.key };
    allAccessLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAccessLog();
  
  
  const change = (page: any) => {
    getAllAccessLog();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片 
 
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAccessLog();
  }
   
 
 
  const updateAccessIntercept = (row: any) => { 
  var data = { "key": row.userId, "id":row.state };
  accessIntercept(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAccessLog();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
    
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: search,
                style: {"text-align":"start"},
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_form_item, {
                    label: "状态",
                    prop: "type",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: search.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.type) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: "0",
                            label: "无登录"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: "1",
                            label: "登录"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (search.type==1)
                    ? (_openBlock(), _createBlock(_component_lay_form_item, {
                        key: 0,
                        label: "账号",
                        prop: "key",
                        mode: "inline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_input, {
                            modelValue: search.key,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.key) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_lay_form_item, { mode: "inline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        size: "sm",
                        onClick: searchUser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  (row.state==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "已处理"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, "未处理"))
                ]),
                operator: _withCtx(({ row }) => [
                  (row.type==1&& row.state==0)
                    ? (_openBlock(), _createBlock(_component_lay_button, {
                        key: 0,
                        size: "xs",
                        type: "primary",
                        onClick: ($event: any) => (updateAccessIntercept(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("禁用")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.type==1&& row.state==1)
                    ? (_openBlock(), _createBlock(_component_lay_button, {
                        key: 1,
                        size: "xs",
                        type: "primary",
                        onClick: ($event: any) => (updateAccessIntercept(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已禁用")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})